import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useDispatch } from "react-redux";

import { history } from "_helpers";
import { userActions, alertActions } from "_store";

import "./login_reg.css";
import "./register.css";

export { Register };

function Register(props) {
  const [businessOption, setbBsinessOption] = useState("no");
  const [natureOption, setNatureOption] = useState("manufacturer")
  const dispatch = useDispatch();

  // form validation rules
  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    username: Yup.string().required("Username is required"),
    password: Yup.string()
      .required("Password is required")
      .min(6, "Password must be at least 6 characters"),
  });
  const formOptions = { resolver: yupResolver(validationSchema) };

  // get functions to build form with useForm() hook
  const { register, handleSubmit, formState } = useForm(formOptions);
  const { errors, isSubmitting } = formState;

  async function onSubmit(data) {
    dispatch(alertActions.clear());
    try {
      await dispatch(userActions.register(data)).unwrap();

      // redirect to login page and display success alert
      history.navigate("/account/login");
      dispatch(
        alertActions.success({
          message: "Registration successful",
          showAfterRedirect: true,
        })
      );
    } catch (error) {
      dispatch(alertActions.error(error));
    }
  }

  const onBusinessValueChange = (e) => {
    setbBsinessOption(e);
  };
  const onNatureOptions = (e) => {
    setNatureOption(e)
  }
  return (
    <section className="login-page-popup fixed d-flex align-center justify-center">
      <div className="login-page-popup-body d-flex relative flex-col" ref={props.registerRefModal}>
        <button type="button" className="btns lp-close-btn">
          <img src="../images/cross-icon.svg" alt="" />
        </button>
        <div className="login-p-title d-flex align-center justify-center relative">
          Welcome to Octa
        </div>
        <div className="popup-line d-felx relative"></div>
        <div className="lp-form relative">
          <form className="relative d-flex flex-col">
            <div className="form-list d-flex relative justify-between">
              <div className="form-group d-flex relative flex-col">
                <label className="form-label d-flex relative">First Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter first name"
                />
              </div>
              <div className="form-group d-flex relative flex-col">
                <label className="form-label d-flex relative">Middle Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter second name"
                />
              </div>
              <div className="form-group d-flex relative flex-col">
                <label className="form-label d-flex relative">Last Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter last Name"
                />
              </div>
            </div>
            <div className="form-list d-flex relative justify-between">
              <div className="form-group d-flex relative flex-col">
                <label className="form-label d-flex relative">Email</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter email address"
                />
              </div>
              <div className="form-group d-flex relative flex-col">
                <label className="form-label d-flex relative">Phone number</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter phone number"
                />
              </div>
              <div className="form-group d-flex relative flex-col">
                <label className="form-label d-flex relative">Country code</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Country code"
                />
              </div>
            </div>
            <div className="popup-line"></div>
            <div className="form-list d-flex relative justify-between">
              <div className="form-group d-flex relative flex-col">
                <label className="form-label d-flex relative">Company name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter company name"
                />
              </div>
              <div className="form-group d-flex relative flex-col">
                <label className="form-label d-flex relative">Business entity type</label>
                <select className="form-control" defaultValue={"DEFAULT"}>
                  <option hidden value="DEFAULT" disabled>
                    Choose entity type
                  </option>
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                </select>
              </div>
            </div>
            <div className="form-list d-flex relative justify-between">
              <div className="form-group d-flex relative flex-col">
                <label className="form-label d-flex relative">Date of incorporation</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter company name"
                />
              </div>
              <div className="form-group d-flex relative flex-col">
                <label className="form-label d-flex relative">Country of incorporation</label>
                <select className="form-control" defaultValue={"DEFAULT"}>
                  <option hidden value="DEFAULT" disabled>
                    Choose entity type
                  </option>
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                </select>
              </div>
            </div>
            <div className="form-list d-flex relative justify-between">
              <div className="form-group d-flex relative flex-col">
                <label className="form-label d-flex relative">
                  TIN or VAT registration number
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter number"
                />
              </div>
              <div className="form-group d-flex relative flex-col"></div>
            </div>
            <div className="popup-line"></div>
            <div className="form-list d-flex relative justify-between">
              <div className="form-group business-group d-flex relative flex-col">
                <div className="form-label-title">
                  What’s your Nature of business
                </div>
                <label className="form-business-label d-flex relative align-center justify-start" onClick={() => onNatureOptions("manufacturer")}>
                  <input
                    type="radio"
                    className="form-control"
                    name="nature-of-business"
                    value="manufacturer"
                    checked={natureOption === "manufacturer"}
                  />{" "}
                  <span>Manufacturer</span>
                </label>
                <label className="form-business-label d-flex relative align-center justify-start" onClick={() => onNatureOptions("distributer")}>
                  <input
                    type="radio"
                    className="form-control"
                    name="nature-of-business"
                    value="distributer"
                    checked={natureOption === "distributer"}
                  />{" "}
                  <span>Distributer</span>
                </label>
              </div>
              <div className="form-group d-flex relative flex-col">
                <label className="form-label d-flex relative">Country of incorporation</label>
                <select className="form-control" defaultValue={"DEFAULT"}>
                  <option hidden value="DEFAULT" disabled>
                    Choose entity type
                  </option>
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                </select>
              </div>
            </div>
            <div className="popup-line"></div>
            <div className="form-list d-flex relative justify-between">
              <div className="form-group business-group d-flex relative flex-col">
                <div className="form-label-title">
                  Have you done business with us?
                </div>{" "}
                <label
                  className="form-business-label d-flex relative align-center justify-start"
                  onClick={() => onBusinessValueChange("yes")}
                >
                  <input
                    type="radio"
                    className="form-control"
                    name="businessWithUs"
                    value="yes"
                    checked={businessOption === "yes"}
                  />{" "}
                  <span>Yes</span>
                </label>
                <label
                  className="form-business-label d-flex relative align-center justify-start"
                  onClick={() => onBusinessValueChange("no")}
                >
                  <input
                    type="radio"
                    className="form-control"
                    name="businessWithUs"
                    value="no"
                    checked={businessOption === "no"}
                  />{" "}
                  <span>No</span>
                </label>
              </div>
              <div className="form-group d-flex relative flex-col">
                <div className="form-group">
                  <label className="form-label d-flex relative">Previous vendor code</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter number"
                  />
                </div>
              </div>
            </div>
            <div className="popup-line"></div>
          </form>
          <div className="lp-form-button d-flex align-center justify-center relative">
            <button type="button" className="btns lp-form-btn" onClick={onSubmit}>
              Signup
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
